module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKBAMAAAB/HNKOAAAAJ1BMVEUAAAAAc8gAcsgAc8kAcskAc8gAc8kAc8gAc8gAcskAcsoAcsgAc8hlbH41AAAADHRSTlMA825yGeezplI5AxxNk2mVAAAAK0lEQVQI12MoYWBgOspwZgID80EGmcMMTEDyTBaYPOMBJndARKCyEJUQXQBUnhQPhuOlKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_bgAfter.png
// module id = iQbi
// module chunks = 9